import axios from "axios";

const prodBaseUrl = "https://api.swimandjoysports.com/api";

const axiosInstance = axios.create({
  baseURL: prodBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

const apiService = {
  baseUrl: prodBaseUrl,

  async get(endpoint) {
    try {
      const response = await axiosInstance.get(endpoint);
      return response.data;
    } catch (error) {
      handleAxiosError(error);
    }
  },

  async getWithToken(endpoint, token) {
    try {
      const response = await axiosInstance.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      handleAxiosError(error);
    }
  },

  async getResourceWithToken(endpoint, token) {
    try {
      const response = await axiosInstance.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      return { data: response.data, success: true };
    } catch (error) {
      return { errorMsg: formatError(error), success: false };
    }
  },

  async postResourceWithToken(endpoint, token, body) {
    try {
      const response = await axiosInstance.post(endpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      return { data: response.data, success: true };
    } catch (error) {
      return { errorMsg: formatError(error), success: false };
    }
  },

  async post(endpoint, body) {
    try {
      const response = await axiosInstance.post(endpoint, body);
      return response.data;
    } catch (error) {
      handleAxiosError(error);
    }
  },

  async postWithToken(endpoint, token, body) {
    try {
      const response = await axiosInstance.post(endpoint, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      handleAxiosError(error);
    }
  },
};

function handleAxiosError(error) {
  console.error("API error:", formatError(error));
  throw error;
}

function formatError(error) {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || error.message;
  }
  return String(error);
}

export default apiService;
